// extracted by mini-css-extract-plugin
module.exports = {"body":"_2t27ry","footer":"_1al2Of"};